//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { get } from 'axios'
import ClickOutside from 'vue-click-outside'
import { SyncLoader } from '@saeris/vue-spinners'

export default {
  name: 'SearchForm',
  
  components: {
    SyncLoader,
  },

  directives: {
    ClickOutside,
  },
  
  props: {
  },

  data() {
    return {
      open: false,
      loading: false,
      value: '',
      results: [],
    };
  },

  created() {
    this.state = this.$props.initialState;
  },

  computed: {
    i18n: function () {
      return wpData.i18n
    },
  },

  methods: {
    openPanel: function () {
      this.open = true

      setTimeout(() => {
        if (this.open) this.$refs['search-value'].focus()
      }, 1)
    },

    hide: function () {
      this.open = false
    },

    search: function () {
      this.loading = true

      get(`${wpData.baseApi}/search`, {
        params: {
          search: this.value,
        },
      })
        .then((response) => {
          console.log(response)

          this.results = response.data
          this.loading = false
        })
    },
  },
};



// WEBPACK FOOTER //
// ./scripts/components/SearchForm/SearchForm.vue